import { Chip } from '@mui/material';
import styled from 'styled-components';

export const StyledTag = styled(Chip)`
  && {
    background-color: ${({ theme }) => theme.palette.tag.background};
    border: 1px solid ${({ theme }) => theme.palette.tag.stroke};
    border-radius: ${({ theme }) => theme.shape.tagRadius};
    height: 1.625rem;
    padding: 0.25rem 0.625rem;
    gap: ${({ theme }) => theme.spacing(2)};
    ${({ theme }) => theme.typography.p9};

    &:hover {
      background-color: ${({ theme, onClick }) =>
        !!onClick && theme.palette.tag.stroke};
    }

    & > span {
      padding: 0;
      ${({ onDelete }) => !!onDelete && 'margin-bottom: 1px'};
    }

    & > svg {
      margin: 0 -0.25rem 0;
      width: 1rem;
      height: 1rem;
      color: ${({ theme }) => theme.palette.secondary.main};

      &:hover {
        ${({ theme, onClick }) =>
          !!onClick && `color: ${theme.palette.secondary.dark};`}
      }
    }
  }
`;
